// Турнирные билеты (docs/spec/07): вход в публичный турнир на 4 или 8 — 1 билет.
// Бесплатные восстанавливаются до максимума раз в сутки, дополнительные — за монеты.

export interface TicketsDto {
  free: number;
  purchased: number;
  total: number;
  /** сколько бесплатных восстанавливается в сутки */
  freeMax: number;
  /** когда бесплатные восстановятся (ISO) */
  nextResetAt: string;
  /** цена билета в монетах */
  price: number;
  /** доп. слоты ежедневного билета за Stars */
  slots: {
    active: number;
    max: number;
    /** когда истекают действующие (ISO, раньше — первым) */
    expiresAt: string[];
    priceStars: number;
    days: number;
    starsEnabled: boolean;
  };
}

/** POST /api/tickets/buy */
export interface BuyTicketResponse {
  tickets: TicketsDto;
  coins: number;
}

/** «через 5 ч 20 мин» до восстановления */
export function resetInText(iso: string, now = Date.now()): string {
  const min = Math.max(0, Math.ceil((Date.parse(iso) - now) / 60_000));
  const h = Math.floor(min / 60);
  return h > 0 ? `${h} ч ${min % 60} мин` : `${min} мин`;
}
